module.exports = __webpack_public_path__ + "static/media/profile-camera.2a1d2260.svg";